import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [showMenu, setShowMenu] = useState(false);

  const whatsappNumbers = [
    { number: '918595672124', label: '+91 8595672124' },
    { number: '917411515444', label: '+91 74115 15444' }
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {showMenu && (
        <div className="mb-4 bg-white rounded-2xl shadow-2xl border border-[#E5E7EB] p-4 min-w-[250px] animate-slide-up">
          <div className="flex items-center justify-between mb-3">
            <h4 className="font-semibold text-[#022C22] text-sm">Contact us on WhatsApp</h4>
            <button 
              onClick={() => setShowMenu(false)}
              className="text-[#4B5563] hover:text-[#022C22]"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="space-y-2">
            {whatsappNumbers.map((contact, index) => (
              <a
                key={index}
                href={`https://wa.me/${contact.number}?text=Hi%2C%20I'm%20interested%20in%20the%20LIVENEAT%20investment%20opportunity`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 p-3 bg-[#D1FAE5] hover:bg-[#10B981] text-[#022C22] hover:text-white rounded-xl transition-all duration-300 group"
              >
                <MessageCircle className="h-4 w-4 flex-shrink-0" />
                <span className="text-sm font-medium">{contact.label}</span>
              </a>
            ))}
          </div>
        </div>
      )}
      
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="bg-[#25D366] hover:bg-[#20BA5A] text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center"
        aria-label="WhatsApp Contact"
        data-testid="whatsapp-button"
      >
        {showMenu ? (
          <X className="h-6 w-6" />
        ) : (
          <MessageCircle className="h-6 w-6" />
        )}
      </button>
    </div>
  );
};

export default WhatsAppButton;
